import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { AdditionalInformation } from '../../types/data';
import { MarkdownHooks } from 'react-markdown';
import DownloadButton from '../download-button/download-button';

type ModalInformationProps = {
  isOpen: boolean;
  onClose: () => void;
  data: AdditionalInformation | null;
};

function ModalInformation({ data, isOpen, onClose }: ModalInformationProps) {
  console.log('ModalInformation', data);
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-40">
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-30 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-4xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute right-[-28px] top-0 outline-none rounded-md text-white opacity-80 hover:opacity-100"
            >
              <span className="sr-only">Close</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>

            <div className="text-sm">
              <h1 className="text-2xl">Документация</h1>

              <div className="mt-2 text-gray-500 wysiwyg">
                <MarkdownHooks>{data?.text}</MarkdownHooks>
              </div>

              <div className="mt-2 flex flex-col gap-0.5">
                {data?.links?.map(({url}, index) => (
                  <a className="text-[#012169]" key={index} href={url} target="_blank" rel="noreferrer">
                    Ссылка
                  </a>
                ))}
              </div>

              <div className="mt-4 flex flex-col gap-3 text-base">
                {data?.files?.map((file, index) => (
                  <DownloadButton
                    key={index}
                    name={file.name as string}
                    src={file.url as string}
                    size={file.size as number}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalInformation;
